// extracted by mini-css-extract-plugin
export default {"container":"transactions_container__8FbZS","table":"transactions_table__sNbHE","heading":"transactions_heading__Kp9sQ"};